module.exports = __webpack_public_path__ + "static/media/om_eyeshape_upturned_amber.85fd5c3a.png";